<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    content-class="gc-dialog"
    overlay-color="#060f23"
    :overlay-opacity="0.82"
    @keydown.esc="cancel"
  >
    <div class="gc-dialog__card">
      <div class="gc-dialog__header">
        <h2 class="gc-dialog__title">Rename</h2>
      </div>
      <p class="gc-dialog__hint">Choose a new name for the file:</p>
      <v-text-field
        v-model="value"
        class="gc-dialog__field"
        dark
        outlined
        dense
        hide-details
        autofocus
        @keyup.enter="rename"
      />
      <div class="gc-dialog__actions">
        <button type="button" class="gc-dialog__btn gc-dialog__btn--text" @click="cancel">
          Cancel
        </button>
        <button type="button" class="gc-dialog__btn gc-dialog__btn--gold" @click="rename">
          Rename
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    value: null,
    options: {
      color: 'primary',
      width: 440
    }
  }),

  methods: {
    open(filename, options) {
      this.value = filename;
      this.dialog = true;
      this.options = Object.assign({}, this.$options.data().options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    rename() {
      this.resolve(this.value);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/brand';

::v-deep .gc-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

.gc-dialog__card {
  background: linear-gradient(145deg, $gc-panel-dark 0%, $gc-panel-mid 100%);
  border: 1px solid rgba($gc-sky-blue, 0.3);
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
  overflow: hidden;
}

.gc-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid rgba($gc-sky-blue, 0.15);
  background: rgba($gc-navy, 0.4);
}

.gc-dialog__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: $gc-white;
}

.gc-dialog__hint {
  margin: 16px 20px 8px;
  font-size: 14px;
  color: rgba($gc-white, 0.65);
  text-align: center;
}

.gc-dialog__field {
  padding: 0 20px 8px;
}

::v-deep .gc-dialog__field.v-text-field--outlined fieldset {
  border-color: rgba($gc-sky-blue, 0.35) !important;
}

::v-deep .gc-dialog__field input {
  color: rgba($gc-white, 0.92) !important;
}

.gc-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 16px;
  border-top: 1px solid rgba($gc-sky-blue, 0.12);
  background: rgba($gc-panel-dark, 0.5);
}

.gc-dialog__btn {
  padding: 8px 18px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &--text {
    color: rgba($gc-white, 0.75);
    background: transparent;

    &:hover {
      color: $gc-white;
      background: rgba($gc-white, 0.06);
    }
  }

  &--gold {
    @include gc-button-gold;
  }
}
</style>
